module.exports = __webpack_public_path__ + "img/uid-token-game-guide.0389de00.png";